import React, { useEffect, useState } from 'react';
import { Button, Text, View, Input, Modal, FormControl, ChevronLeftIcon } from 'native-base';
import { liveTTScoreboardButtonTextColor } from '../../../livettscoreboard.config';
import { addImportedPlayer, editImportedPlayer } from '../functions/players';
import { newImportedPlayer } from '../classes/Player';
import CountryFlagList from '../components/CountryFlagList';

export function AddNewPlayerModal(props) {

    console.log(props)

    let [firstName, setFirstName] = useState("");
    let [lastName, setLastName] = useState("");
    let [imageURL, setImageURL] = useState("");
    let [country, setCountry] = useState("");
    let [allCountries, setAllCountries] = useState({});

    let [showCountrySelection, setShowCountrySelection] = useState(false);

    function canSubmit() {
        if (firstName && firstName.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }

    useEffect(() => {
        async function getCountryNames() {
            let flagList = await import('../flags/countries.json');
            setAllCountries(flagList);
        }
        getCountryNames();

    }, []);

    const resetPlayerFields = () => {
        setFirstName("");
        setLastName("");
        setImageURL("");
        setCountry("");
    };

    useEffect(() => {
        setFirstName(props.firstName || "");
        setLastName(props.lastName || "");
        setImageURL(props.imageURL || "");
        setCountry(props.country || "");
    }, [props.firstName, props.lastName, props.imageURL, props.country]);

    //console.log(props, firstName, lastName, imageURL)
    return (
        <Modal isOpen={props.isOpen}
            onClose={() => {
                props.onClose();
            }}
        >
            <Modal.Content>
                <Modal.CloseButton></Modal.CloseButton>
                <Modal.Header>Add New Player</Modal.Header>
                <Modal.Body>
                    <FormControl>
                        {showCountrySelection ?
                            <>
                                <View>
                                    <Button padding={1} justifyContent={"flex-start"} variant={"ghost"} onPress={() => {
                                        setShowCountrySelection(false);
                                    }}>
                                        <View alignItems={"center"} flexDirection={"row"}>
                                            <ChevronLeftIcon></ChevronLeftIcon>
                                            <Text>Back</Text>
                                        </View>

                                    </Button>
                                </View>
                                <CountryFlagList onSelection={(countryCode) => {
                                    setCountry(countryCode);
                                    setShowCountrySelection(false);
                                }}></CountryFlagList>
                            </>


                            :
                            <>
                                <FormControl.Label>
                                    First Name
                                </FormControl.Label>
                                <Input value={firstName}
                                    onChangeText={(text) => {
                                        setFirstName(text);
                                    }}
                                ></Input>

                                <FormControl.Label>
                                    Last Name
                                </FormControl.Label>
                                <Input value={lastName}
                                    onChangeText={(text) => {
                                        setLastName(text);
                                    }}
                                ></Input>

                                <FormControl.Label>
                                    Image URL
                                </FormControl.Label>
                                <Input value={imageURL}
                                    onChangeText={(text) => {
                                        setImageURL(text);
                                    }}
                                ></Input>
                                <FormControl.Label>
                                    Country
                                </FormControl.Label>
                                <Button onPress={() => {
                                    setShowCountrySelection(true);
                                }}>
                                    <Text color={liveTTScoreboardButtonTextColor}>{country.length > 0 ? allCountries[country.toUpperCase()] : "Select Country"}</Text>
                                </Button>
                            </>}

                    </FormControl>
                </Modal.Body>
                <Modal.Footer>
                    <View>
                        <Button disabled={!canSubmit()}
                            onPress={async () => {
                                if (props.isEditing) {
                                    let player = newImportedPlayer(firstName, lastName, imageURL, country);
                                    console.log(props.route.params.playerListID, props.id, player)
                                    await editImportedPlayer(props.route.params.playerListID, props.id, player);
                                    props.onClose();
                                    props.onConfirmEdit(
                                        {
                                            ...player,
                                            id: props.id
                                        }
                                    );
                                    resetPlayerFields();

                                }
                                else {
                                    let newPlayer = newImportedPlayer(firstName, lastName, imageURL, country);
                                    let playerID = await addImportedPlayer(props.route.params.playerListID, newPlayer);
                                    props.onConfirmAdd({
                                        ...newPlayer,
                                        id: playerID
                                    });
                                    props.onClose();
                                    resetPlayerFields();
                                }

                            }}

                        >
                            <Text color={liveTTScoreboardButtonTextColor}>{props.isEditing ? "Update" : "Add"}</Text>
                        </Button>
                    </View>
                    <View>
                        <Button variant={"ghost"}
                            onPress={() => {
                                props.onClose();
                            }}
                        >
                            <Text>Close</Text>
                        </Button>
                    </View>
                </Modal.Footer>
            </Modal.Content>
        </Modal>
    );
}
